import SurfaceBase, { type SurfaceBaseOptions } from './SurfaceBase';

interface PassthroughSurfaceOptions extends SurfaceBaseOptions {}

export default class PassthroughSurface extends SurfaceBase {
  onMouseEvent = (e: MouseEvent) => {
    this.bubbleEventToMap(e);
  };
}
